import { render, staticRenderFns } from "./legend-panel.vue?vue&type=template&id=16925b20&scoped=true&"
import script from "./legend-panel.vue?vue&type=script&lang=js&"
export * from "./legend-panel.vue?vue&type=script&lang=js&"
import style0 from "./legend-panel.vue?vue&type=style&index=0&id=16925b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16925b20",
  null
  
)

export default component.exports